import { createSlice } from "@reduxjs/toolkit";
import { WebPushState } from "shared/types/webPush";

const initialState: WebPushState = {
  popupType: null,
  user: null,
  firebaseLoaded: false,
  firebaseSendRequest: false,
  subscribed: {
    isOpenPopup: false,
    isSubscribed: false,
  },
};

const webPushSlice = createSlice({
  name: "webPush",
  initialState,
  reducers: {
    showPopup(state, { payload }) {
      state.popupType = payload.type;
      state.user = payload.user;
    },
    hidePopup(state) {
      state.popupType = null;
      state.user = null;
    },
    firebaseLoaded: (state, { payload }) => {
      state.firebaseLoaded = payload;
    },
    firebaseSend: (state, { payload }) => {
      state.firebaseSendRequest = payload;
    },
    setSubscribedPopup: (state, { payload }) => {
      state.subscribed.isOpenPopup = payload.isOpenPopup;

      if (typeof payload.isSubscribed !== "undefined") {
        state.subscribed.isSubscribed = payload.isSubscribed;
      }
    },
  },
});

export const {
  showPopup,
  hidePopup,
  firebaseLoaded,
  firebaseSend,
  setSubscribedPopup,
} = webPushSlice.actions;

export default webPushSlice.reducer;
